export const PRODUCT_TYPES = {
    GROUP_MEMBERSHIP: 'GROUP_MEMBERSHIP',
    GROUP_FREE_MEMBERSHIP: 'GROUP_FREE_MEMBERSHIP',
    GROUP_SUBSCRIPTION: 'GROUP_SUBSCRIPTION',
    GROUP_FREE_SUBSCRIPTION: 'GROUP_FREE_SUBSCRIPTION',
};

export default PRODUCT_TYPES;
